import axios from "axios";

let instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: "json",
});

instance.defaults.headers.common[
  "Authorization"
] = `Bearer ${localStorage.getItem("gs3_AuthToken")}`;

export default instance;
